import {
  type EquipmentAccessorial,
  equipmentAccessorialSchema,
} from '../equipment/accessorials.ts'
import type { EquipmentType } from '../equipment/constants.ts'
import { vEquipmentType } from '../equipment/utils.ts'
import {
  vArray,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'
import { type Currency, type Mode, modes, type WeightUOM } from './common.ts'

export const loadEquipmentSchema = vObject({
  // loadId: vObjectId(),
  // quoteId: vOptional(vObjectId()),
  mode: vPicklist(modes),
  type: vEquipmentType(),
  alternateTypes: vOptional(vArray(vEquipmentType())),
  accessorials: vOptional(vArray(equipmentAccessorialSchema)),
  description: vOptional(vString()),
  declaredValue: vOptional(vNumber()),
  // declaredValueCurrency: vCurrency(),
  weight: vOptional(vNumber()),
  // weightUOM: vWeightUOM,
  // isHazardous: vBoolean(),
})
export type LoadEquipmentDto = vOutput<typeof loadEquipmentSchema>
export interface LoadEquipment {
  mode: Mode
  type: EquipmentType
  serviceId?: string
  accessorials?: EquipmentAccessorial[]
  pickupConfirmationNumber?: string
  masterTrackingNumber?: string
  declaredValue?: number
  declaredValueCurrency: Currency
  weight: number
  weightUOM: WeightUOM
  description: string
  alternateTypes: EquipmentType[]
  isHazardous: boolean
}
